import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  List,
  ListItemText,
  Divider,
  IconButton,
  Avatar,
  Badge,
  Card,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  AppBar,
  Toolbar,
} from "@mui/material";
import DOMPurify from 'dompurify';
import {
  Notifications,
  CheckCircle,
  Assignment,
  Update,
  PersonOutlineOutlined,
  Close as CloseIcon
} from "@mui/icons-material";

const RightSidebar = () => {
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [imageData, setImageData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    getNotifications();
  }, []);

  async function getNotifications() {
    const token = localStorage.getItem('token') || '';
    const company = localStorage.getItem('company') || '';

    try {
      const response = await fetch(`https://beiguru.co.in/notifications/${company}`, {
        headers: {
          'Authorization': token
        }
      });

      if (response.ok) {
        const result = await response.json();
        setImageData(result);
      } else {
        console.error('Failed to fetch notifications:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
      {/* Header - Bell Icon & Avatar */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Badge badgeContent={imageData.length} color="error">
          <IconButton>
            <Notifications fontSize="large" sx={{ color: "#fff" }} />
          </IconButton>
        </Badge>
        <Avatar
          src={localStorage.getItem("avatar").includes('uploads') ? `https://beiguru.co.in/${localStorage.getItem("avatar")}` : require(`../assets/a${localStorage.getItem("avatar")}.png`)} // Replace with dynamic URL logic if needed
          sx={{ border: "2px solid rgb(255, 255, 255)", bgcolor: "transparent", color: "#fff" }}
          onClick={() => document.getElementById("avatar-upload").click()} // Triggers the file input
        />
      </Box>

      <List sx={{ overflowY: "auto", flexGrow: 1 }}>
        {imageData.slice(0, 5).map((notification) => (
          <Card
            key={notification.id}
            onClick={() => handleNotificationClick(notification)}
            sx={{
              mb: 1,
              p: 2,
              borderRadius: 3,
              boxShadow: 3,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              transition: "0.3s",
              background: "linear-gradient(135deg, #4facfe, #00f2fe)",
              color: "white",
              "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
            }}
          >
            <IconButton sx={{ color: "white", mr: 1 }}><CheckCircle /></IconButton>
            <ListItemText style={{
              fontSize: '14px',
              fontFamily: 'Noto Sans',
              margin: 0,
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              lineHeight: '1.4'
            }} primary={notification.subject} />
          </Card>
        ))}
      </List>

      {/* Full Screen Popup */}
      <Dialog
        fullScreen
        open={isPopupOpen}
        onClose={handleClosePopup}
        sx={{
          '& .MuiDialog-paper': {
            bgcolor: 'background.default'
          }
        }}
      >
        <AppBar sx={{ position: 'relative', background: 'linear-gradient(135deg, #4facfe, #00f2fe)' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClosePopup}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
              Notification Details
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 4 }}>
          {selectedNotification && (
            <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
              <Card sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
                <Box
                  sx={{
                    '& img': { maxWidth: '100%', height: 'auto' },
                    '& a': { color: '#4facfe', textDecoration: 'none' },
                    '& a:hover': { textDecoration: 'underline' },
                    '& p': { margin: '0.5em 0' },
                    '& h1, h2, h3, h4, h5, h6': { color: '#4facfe', fontWeight: 'bold' }
                  }}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(selectedNotification.description)
                  }}
                />
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mt: 2, lineHeight: 1.7 }}>
                  {selectedNotification.message}
                </Typography>
                <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                  <Update sx={{ mr: 1, fontSize: 20 }} />
                  <Typography variant="body2">
                    {new Date(selectedNotification.createdAt).toLocaleString()}
                  </Typography>
                </Box>
              </Card>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Divider sx={{ my: 2 }} />
    </Box>
  );
};

export default RightSidebar;